import { formatMoney } from '../../components/utilities';

const Customizations = {
  // Variável utilizada para identificar os inputs que devem receber o link de imagem
  fileInputs: window.fileInputs,
  // Lida do personalização de arquivos
  customizationsFile: function (currentProduct) {
    if (!currentProduct) return;

    // Verifica elementos de personalização 'Fotos'
    const inputsFile = currentProduct.querySelectorAll('[data-customizations-file]');
    const dropZones = currentProduct.querySelectorAll('[data-customizations-dropzone]');

    if (inputsFile.length > 0 && dropZones.length > 0) {
      // Inicia configurações do webform
      let inputCount = 0;

      // Lida com envio de arquivos via webform
      const handleFiles = (input, files, warning, error, display) => {
        // Verifica formato dos arquivos
        let wrongFiles = files.filter(
          (file) => file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'application/pdf'
        );
        if (!wrongFiles.length) {
          // Armazena nome(s) do(s) arquivo(s)
          let names = '';
          files.forEach((file, i) => {
            names += i == 0 ? file.name : ` | ${file.name}`;
          });

          // Atualiza campo da personalização de texto
          input.dispatchEvent(new Event('input'));
          input.value = names;

          // Cria um objeto do input com o elemento e seus arquivos
          const inputObject = {input: input, files: files}

          // Insere/substitui o objeto no array global com o elemento e arquivos do input
          Customizations.fileInputs[inputCount] = inputObject;

          // Atualiza contador de campos do webform
          inputCount++;

          // Atualiza elementos informativos
          if (display) display.innerHTML = names;
          if (warning) warning.classList.add('-active');

          // Remove campo de arquivos do webform ao editar campo da personalização de texto
          const removeInput = () => {
            // Deleta do array de objetos de inputs caso exista
            if (Customizations.fileInputs[inputCount]) {
              delete Customizations.fileInputs[inputCount];
            }
 
            // Atualiza contador e desabilita envio
            inputCount--;

            // Atualiza elementos informativos
            if (display) display.innerHTML = 'Arraste ou solte os arquivos';
            if (warning) warning.classList.remove('-active');

            input.removeEventListener('input', removeInput);
          };
          input.addEventListener('input', removeInput);
        } else if (error) {
          // Exibe mensagem de erro referente ao formato dos arquivos
          error.classList.add('-active');
          setTimeout(() => {
            error.classList.remove('-active');
          }, 5000);
        }
      };

      // Lida com campo para selecionar arquivos
      inputsFile.forEach((inputFile) => {
        if (inputFile.closest('.inner').querySelector('input[data-customization-text]'))
          inputFile.closest('.inner').querySelector('input[data-customization-text]').value = '';
        inputFile.addEventListener('change', (e) => {
          e.preventDefault();

          let display = inputFile.closest('.inner').querySelector('[data-customizations-display]');
          let inputText = inputFile.closest('.inner').querySelector('input[data-customization-text]');
          let messageWarning = inputFile.closest('.inner').querySelector('[data-customizations-message-warning]');
          let messageError = inputFile.closest('.inner').querySelector('[data-customizations-message-error]');

          // Tamanho máximo em megabytes
          const maxSizeMB = 10;
          const maxSizeBytes = maxSizeMB * 1024 * 1024;

          const files = [...e.target.files];
          // Filtra os arquivos que excedem o limite
          const oversizedFiles = files.filter(file => file.size > maxSizeBytes);

          if (oversizedFiles.length > 0) {
            // Exibe mensagem de erro referente ao tamanho dos arquivos
            if (messageError) {
              messageError.innerHTML = `O tamanho máximo permitido é ${maxSizeMB}MB.`;
              messageError.classList.add('-active');
              setTimeout(() => {
                messageError.classList.remove('-active');
              }, 5000);
            }
            return;
          }

          if (files.length > 0) handleFiles(inputText, files, messageWarning, null, display);
        });
      });

      // Lida com zona para arrastar arquivos
      dropZones.forEach((dropZone) => {
        dropZone.addEventListener('dragover', (e) => {
          e.preventDefault();
        });
        dropZone.addEventListener('drop', (e) => {
          e.preventDefault();

          let display = dropZone.closest('.inner').querySelector('[data-customizations-display]');
          let inputText = dropZone.closest('.inner').querySelector('input[data-customization-text]');
          let messageWarning = dropZone.closest('.inner').querySelector('[data-customizations-message-warning]');
          let messageError = dropZone.closest('.inner').querySelector('[data-customizations-message-error]');

          let files = e.dataTransfer.items
            ? [...e.dataTransfer.items].filter((item) => item.kind === 'file').map((item) => item.getAsFile())
            : e.dataTransfer.files
            ? [...e.dataTransfer.files]
            : [];

          if (files.length > 0) handleFiles(inputText, files, messageWarning, messageError, display);
        });
      });
    }
  },

  // Lida com personalização das faixas
  handleBandCustominization: function () {
    const custominizationBands = document.querySelectorAll('.customization-bands');
    const productBox = document.querySelector('[data-product-box]');

    if (custominizationBands.length > 0) {

      custominizationBands.forEach(custominizationBand => {
        const actionBand = custominizationBand.querySelector('.action-band');
        const colorInputs = custominizationBand.querySelectorAll('[data-color-band-sku] input');
        let buttonBand = custominizationBand.querySelectorAll('[data-button-band-sku]');

        colorInputs.length > 0 && colorInputs.forEach(input => {
          input.addEventListener('click', (e) => { 
            e.preventDefault(); 

            
            setTimeout(() => {
              input.checked ? input.checked = false : input.checked = true;
            }, 5)
          })
        })
   
        if (buttonBand)
          buttonBand.forEach((button) => {
            button.addEventListener('click', () => {
              const activeColor = custominizationBand.querySelector('[data-color-band-sku].-show');
              const activeButton = custominizationBand.querySelector('[data-button-band-sku].-active');
              if (activeColor) {
                activeColor.classList.remove('-show')
                activeColor.querySelectorAll('input').forEach(input => input.disabled = true)
              };
              if (activeButton) activeButton.classList.remove('-active');
  
              const buttonSku = button.getAttribute('data-button-band-sku');
              const colorSku = custominizationBand.querySelector(`[data-color-band-sku='${buttonSku}']`);
              const topicTitle = custominizationBand.querySelector('.topic-title');
  
              button.classList.add('-active');
              topicTitle.classList.add('-show');
              colorSku.classList.add('-show');
              colorSku.querySelectorAll('input').forEach(input => input.disabled = false)

            }); 
          });
      })
    }
  },

  // Valida disponibilidade da compra considerando as personalizações de cores de faixas selecionadas
  validateBandCustomization: function (product) {
    if (!product) return;

    // Seleciona os inputs de cores
    const inputsToValidate = product.querySelectorAll('[data-color-band-sku] input')
    
    if (!inputsToValidate.length > 0) return
    
    let hasColorSelected = [];

    // Verifica se há input selecionado e habilitado
    hasColorSelected = [...inputsToValidate].filter(input => {
      return input.checked && !input.disabled 
    });

    if (hasColorSelected.length > 0) return true

    if (!hasColorSelected.length > 0) return false

   
  },

  // Configura exibição do valor individual de cada personalização
  handleIndividualPrices: function () {
    const customs = document.querySelectorAll('[data-custom-option]');

    customs.forEach((custom) => {
      const value = custom.querySelector('[data-value]');
      const price = custom.querySelector('[data-customization-price]');

      if (price) {
        const valuePrice = price.getAttribute('data-customization-price');

        if (valuePrice && Number(valuePrice) > 0) {
          if (window.location.search.includes(`language=en`)) {
            let valueDolar = valuePrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
            value.innerHTML = `(+ $${valueDolar})`;
          } else {
            value.innerHTML = `(+ ${formatMoney(Number(valuePrice))})`;
          }
        }
      }
    });
  },

  handleSelectCustomizations: function () {
    const custom = document.querySelector('.customization');

    if (custom) {
      const customOptions = custom.querySelectorAll('[data-custom-option]');
      const button = custom.querySelector('[data-button-custominization]');

      if (button)
        button.addEventListener('click', () => {
          custom.classList.toggle('-hidden');
        });

      if (customOptions.length > 0)
        customOptions.forEach((option) => {
          let buttonCheck = option.querySelector('[data-custominization-check]');

          //Habilita/Desabilita a personalização
          buttonCheck.addEventListener('click', () => {
            let optionsCheck = custom.querySelector('[data-custom-option].-show');

            if (optionsCheck) {
              optionsCheck.classList.remove('-show');

              // Desabilita os inputs do elemento que acabou de perder a classe '-show'
              const previousInputs = optionsCheck.querySelectorAll('[data-customization]');
              previousInputs.forEach((input) => {
                input.setAttribute('disabled', 'disabled');
              });
            }

            // Adiciona a classe '-show' ao elemento atual
            option.classList.add('-show');

            // Habilita os inputs do elemento que acabou de receber a classe '-show'
            const inputs = option.querySelectorAll('[data-customization]');
            inputs.forEach((input) => {
              input.removeAttribute('disabled');
            });
          });
        });
    }
  },

  setLetterCustominization: function () {
    const customLetter = document.querySelector('[data-custom-letter]');

    if (customLetter) {
      const input = customLetter.querySelector('[data-customization]');
      const topLetter = customLetter.querySelector('[data-top-letter]');
      const clean = customLetter.querySelector('[data-clean-letter]');
      const letters = customLetter.querySelectorAll('[data-letter-custominization]');
      let arrayLetters = [];

      //LIDA COM OS EVENTOS DAS LETRAS
      if (letters.length > 0)
        letters.forEach((letter) => {
          letter.addEventListener('change', (e) => {
            let value = letter.getAttribute('data-letter-custominization');
            let lettersCheckeds = customLetter.querySelectorAll('[data-letter-custominization]:checked');

            if (lettersCheckeds.length <= 3) {
              if (arrayLetters.length <= 2) arrayLetters.push(value);

              if (lettersCheckeds.length == 3) customLetter.classList.add('-block');
            } else {
              letter.checked = false;
            }

            input.value = '';
            topLetter.classList.add('-show');
            arrayLetters.forEach((arrayLetter, i) => {
              input.value = i == 0 ? arrayLetter : input.value + ` ${arrayLetter}`;
            });
          });
        });

      //LIDA COM O BOTÃO DE LIMPAR
      if (clean)
        clean.addEventListener('click', () => {
          input.value = '';
          arrayLetters = [];
          topLetter.classList.remove('-show');
          customLetter.classList.remove('-block');

          letters.forEach((letter) => {
            letter.checked = false;
          });
        });
    }
  },

  // Marca a primeira opção das customizações que possuem mais de uma opção
  markFirstOption: function () {
    const customs = document.querySelectorAll('[data-custom-option]');
    customs.forEach((custom) => {
      const inputs = custom.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      if (inputs.length > 0) {
        const firstAvailable = custom.querySelector('.label.-available');
        if (firstAvailable) firstAvailable.click();
      }
    });
  },

  init: function () {
    this.handleBandCustominization();
    this.handleIndividualPrices();
    this.handleSelectCustomizations();
    this.setLetterCustominization();
    this.markFirstOption();

    const productBox = document.querySelector('[data-product-box]');
    this.customizationsFile(productBox);
  },
};

export default Customizations;
